import Blockly from 'blockly/browser'
import _ from 'lodash'

export function defineBlock(id, defObj, codeGenFunc, initFn = () => {}) {
  defObj.type = id
  if (!defObj.colour) {
    defObj.colour = colors.api
  }
  Blockly.Blocks[id] = {
    init: function() {
      this.jsonInit(defObj)
      initFn.apply(this)
    }
  }
  Blockly.JavaScript[id] = codeGenFunc
}

export function defineStmtBlock(id, defObj, codeGenFunc, initFn = () => {}) {
  defObj.previousStatement |= null
  defObj.nextStatement |= null
  defineBlock(id, defObj, codeGenFunc, initFn)
}

export function defineExprBlock(id, defObj, codeGenFunc) {
  defObj.output |= null
  defineBlock(id, defObj, codeGenFunc)
}

export function isValidIdentifier(identifier) {
  return /^[a-zA-Z_$][a-zA-Z_$0-9]*$/.test(identifier)
}

export function getOptionsCode(props, block, extraProps) {
  props = props != null ? props : []
  let optionStrings = props.map(propName => {
    const name = isValidIdentifier(propName) ? propName : `'${propName}'`
    return `${name}: ${Blockly.JavaScript.valueToCode(
      block,
      propName,
      Blockly.JavaScript.ORDER_ATOMIC
    ) || 'null'}`
  })
  if (extraProps) {
    optionStrings = optionStrings.concat(
      _.keys(extraProps).map(propKey => {
        const name = isValidIdentifier(propKey) ? propKey : `'${propKey}'`
        return `${name}: ${extraProps[propKey]}`
      })
    )
  }
  const options = Blockly.JavaScript.prefixLines(
    optionStrings.join(',\n'),
    Blockly.JavaScript.INDENT
  )
  return optionStrings.length === 0 ? '{}' : `{\n${options}\n}`
}

const colors = {
  objects: 50,
  field: 80,
  misc: 140,
  api: 175,
  // Almost the hue of functions since running a flow is similar to calling a function
  flow: parseInt(Blockly.Msg.PROCEDURES_HUE, 10) + 20
}

function collectStatementBlocks(block) {
  const collection = []
  do {
    collection.push(block)
    block = block.getNextBlock()
  } while (block)
  return collection
}

export function getStatements(block) {
  if (!block) {
    return []
  }
  const statementBlocks = collectStatementBlocks(block)
  let codeForStatements = statementBlocks.map(b => Blockly.JavaScript[b.type](b, b))
  codeForStatements = codeForStatements.map(c => c.replace(/;?\n?$/, ''))
  return codeForStatements
}

export function mapSireniaPrimitiveToBlocklyPrimitive(sireniaType) {
  return sireniaType === 'string'
    ? 'String'
    : sireniaType === 'number'
    ? 'Number'
    : sireniaType === 'boolean'
    ? 'Boolean'
    : null
}

export default {
  colors
}
